var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5D254A62-ED46-44F4-B21B-F24130DE0856@1,5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "05---Defini\\xE7\\xF5es",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MY-D-05-01-05-confirmacao",
    transform: "translate(-704.000000, -136.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(470.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(49.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/alert_time",
    transform: "translate(185.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,0 C7.17995444,0 0,7.15981735 0,16 C0,24.8401826 7.17995444,32 16,32 C24.8200456,32 32,24.8401826 32,16 C32,7.15981735 24.8200456,0 16,0 Z",
    id: "Shape",
    fill: "#930202"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.761912,19 L15.761912,16.9047619 C17.0686558,16.8793651 18.1016898,16.5333333 18.8610139,15.8666667 C19.620338,15.2 20,14.2063492 20,12.8857143 C20,11.6666667 19.646826,10.7142857 18.940478,10.0285714 C18.23413,9.34285714 17.2923327,9 16.115086,9 C15.2674684,9 14.5316892,9.16825397 13.9077485,9.5047619 C13.2838078,9.84126984 12.8070229,10.3047619 12.4773938,10.8952381 C12.1477648,11.4857143 11.9888365,12.1619048 12.0006089,12.9238095 L12.0006089,12.9238095 L13.9254072,12.9238095 C13.9254072,12.2888889 14.1196529,11.7746032 14.5081443,11.3809524 C14.8966357,10.9873016 15.408738,10.7904762 16.0444512,10.7904762 C16.644847,10.7904762 17.1216319,10.9777778 17.4748059,11.352381 C17.8279799,11.7269841 18.0045669,12.2444444 18.0045669,12.9047619 C18.0045669,13.8825397 17.7102552,14.552381 17.1216319,14.9142857 C16.5330086,15.2761905 15.7265946,15.4571429 14.70239,15.4571429 L14.70239,15.4571429 L13.8547724,15.4571429 L13.8547724,19 L15.761912,19 Z M16,23 L16,21 L14,21 L14,23 L16,23 Z",
    id: "?",
    fill: "#FFFFFF"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertQuestion);
export default __webpack_public_path__ + "static/media/alert-question.a4029f676f708ae5add712aaa1d4d7bb.svg";
export { ForwardRef as ReactComponent };